var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_589_2001",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_589_2001",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAZKADAAQAAAABAAAAZAAAAAAvu95BAAADHUlEQVR4Ae2dQW7TQBSG6wrRBT0AiCuAgE0FdyhL2HRd2MESjlCugFiGI3CHsgEk6BFQu4YiQTfhfy0UJcQzkaWZ+eN8I00Vz9h+z9+XF9utnG5s0CAAAQhAAAIQgAAEIAABCNQl0P0NN51Ot/T6ifqe+i31a+q0cgR+aNdf1Cfqr7uuO4tQ50Ik46Zev1O/E4O06gQ+KeKupHzt/lTGew0go7qHmYAftXR/Uz+eqiNjhk2ThXuKuh8VEtWx0yQFgs4TOAwh3zW6PT/DchMCpyFk2iQ0QRcSiHMIzYgAQoxkRCoIQYgZAbN0qBCEmBEwS4cKQYgZAbN0qBCEmBEwS4cKQYgZAbN0qBCEmBEwS4cKQYgZAbN0qBCEmBEwS4cKQYgZAbN0qBCEmBEwS4cKQYgZAbN0qBCEmBEwS4cKQYgZAbN0qBCEmBEwS4cKQYgZAbN0qBCEmBEwS4cKMRNyZWg+esj98lsghu5jzNsNfXaTCjF7VyAEIWYEzNKhQhBiRsAsHSoEIWYEzNIpViG6Dn+sfhzX43Mtxh7lOGidld4+d3x984O/fCZ3Yyigxwp6vSfwiba/0TN3PjyC7Qd9qU9JIcmElhA66u373ozFPrL6AjKeJoCQNJ/qswipjjwdsKSQk0ToOOHn2qpvnzu+hfMlhTxTxEVQQ8bzhdnMDq769rNHs+RSsausJeOPdjVdtievEvsOvGSF9MVkPEEAIQk4LaYQ0oJ6IiZCEnBaTCGkBfVETIQk4LSYQkgL6omYg+9DEvtclalX+o3zy1yyQ+8ncvvtm1/nCnkh2Ad9YFqNr7OQYG4nZd2F2ElByMVnk02lIORCiE2lIOSfEAspCJkV0lwKQv4X0lTK4Ad2Fh/HqEbjRP+z9hGt8516bdZLxeMjaylM9VYKIaf1whEpQ+BbCDnKrMR0PQJHIeRtvXhEyhCYxEl9Sysdqt/NrMx0WQIftPsHm/qbwC+92FWP/+dNa0MgZDyUi7PLh/9VKVc1uK++p35bnf8gLQgFW1xMfVafqL8JGQVjsWsIQAACEIAABCAAAQhAAAK9BH4DhrI1MQKzOvIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatOn);
export default __webpack_public_path__ + "static/media/chat_on.fee7066448d85b2dcbb1b9e6d9e00fff.svg";
export { ForwardRef as ReactComponent };